(function () {
	'use strict';

	angular
		.module('invesfleet')
		.controller('LogisticsManagementController', LogisticsManagementController);

	LogisticsManagementController.$inject = [
		'$scope',
		'$rootScope',
		'$window',
		'userService',
		'ordersService',
		'$templateCache',
		'$timeout',
		'$filter',
		'fleet',
		'preferences',
		'$state',
		'ModalService',
		'reportService',
		'aceptacionServicioService',
		'notificationService',
		'simpleModalService',
		'genericDataService',
		'common',
		'uiGridConstants'
	];

	/* jshint maxstatements:false, maxparams:false */
	function LogisticsManagementController(
		$scope,
		$rootScope,
		$window,
		userService,
		ordersService,
		$templateCache,
		$timeout,
		$filter,
		fleet,
		preferences,
		$state,
		ModalService,
		reportService,
		aceptacionServicioService,
		notificationService,
		simpleModalService,
		genericDataService,
		common,
		uiGridConstants
	) {

		/* PRIVATE VARIABLES */
		var assignDriverTemplate = $templateCache.get('app/views/modals/assignDriverTemplate.html');
		var acceptServiceTemplate = $templateCache.get('app/views/modals/aceptacion/acceptServiceTemplate.html');
		var templatesBase = 'app/views/tablesTemplates/logisticsManagement/';
		var templates = {
			headerTemplate: $templateCache.get(templatesBase + 'headerTemplate.html'),
			headerCellTemplate: $templateCache.get(templatesBase + 'headerCellTemplate.html'),
			rowTemplate: $templateCache.get(templatesBase + 'rowTemplate.html'),
			estadoCellTemplateGRU: $templateCache.get(templatesBase + 'estadoCellTemplateGRU.html'),
			estadoCellTemplateTAX: $templateCache.get(templatesBase + 'estadoCellTemplateTAX.html'),
			drecogidaCellTemplate: $templateCache.get(templatesBase + 'dRecogidaCellTemplate.html'),
			dentregaCellTemplate: $templateCache.get(templatesBase + 'dEntregaCellTemplate.html'),
			accionesCellTemplate: $templateCache.get(templatesBase + 'accionesCellTemplate.html'),
			clienteCellTemplate: $templateCache.get(templatesBase + 'clienteCellTemplate.html'),
			choferCellTemplate: $templateCache.get(templatesBase + 'choferCellTemplate.html'),
			typeCellTemplate: $templateCache.get(templatesBase + 'typeOrderCellTemplate.html'),
			delayCellTemplate: $templateCache.get(templatesBase + 'delayCellTemplate.html'),
			vehicleCellTemplate: $templateCache.get(templatesBase + 'vehicleCellTemplate.html'),
			dateCellTemplate: $templateCache.get(templatesBase + 'dateCellTemplate.html'),
			brandCellTemplate: $templateCache.get(templatesBase + 'brandCellTemplate.html'),
		};

		var userConfig = userService.userData;

		var listeners = [];
		var timeouts = [];

		/* PUBLIC VARIABLES */
		var vm = this;
		vm.firstTime = true;

		vm.searchText = '';
		vm.clearSearcher = clearSearcher;

		vm.fleet = fleet;
		vm.preferences = preferences;
		vm.rootScope = $rootScope;
		vm.aceptacionServicioService = aceptacionServicioService;
		vm.common = common;
		vm.showDeactivate = false;
		vm.onMouseOverDelayCell = onMouseOverDelayCell;
		vm.onMouseLeaveDelayCell = onMouseLeaveDelayCell;
		vm.getDelayState = getDelayState;
		vm.getStateClassName = getStateClassName;
		vm.getStateLabel = getStateLabel;

		//GRID
		$scope.gridData = null;
		vm.gridApi = null;
		$scope.gridOptions = {
			//headerTemplate: templates.headerTemplate,
			//headerCellTemplate: templates.headerCellTemplate,
			rowTemplate: templates.rowTemplate,
			enableGridMenu: true,
			enableColumnMenus: false,
			treeRowHeaderAlwaysVisible: false,

			//With virtualization we lower the number of watchers (9257 to 4970 with 67 orders for example)
			//Virtualization uses transform: translateY for each row which means that each row creates 
			//each own stacking context and our dropdown menus or any element using z-index wont work well..
			virtualizationThreshold: 200,

			//Row selection
			enableRowHeaderSelection: true,
			enableGroupHeaderSelection: true,
			enableRowSelection: false,
			enableSelectAll: true,
			multiSelect: true,
			enableColumnResizing: true,

			rowHeight: 26,

			primaryKey: 'orderId',
			columnDefs: computeColumnsByOrderType(),
			data: 'gridData',
			onRegisterApi: function (gridApi) {
				vm.gridApi = gridApi;

				vm.gridApi.selection.on.rowSelectionChanged($scope, function (row) {
					var childRows, rowEntity, length, i;

					if (row.internalRow === true && row.isSelected === true) {
						childRows = row.treeNode.children;
						for (i = 0, length = childRows.length; i < length; i++) {
							rowEntity = childRows[i].row.entity;
							vm.gridApi.selection.selectRow(rowEntity);
						}
					}

					if (row.internalRow === true && row.isSelected === false) {
						childRows = row.treeNode.children;
						for (i = 0, length = childRows.length; i < length; i++) {
							rowEntity = childRows[i].row.entity;
							vm.gridApi.selection.unSelectRow(rowEntity);
						}
					}

				});

				vm.gridApi.grid.registerDataChangeCallback(function () {
					angular.forEach(vm.gridApi.grid.grouping.groupingHeaderCache, function (value, key) {
						if (!value.row.userSet) {
							vm.gridApi.treeBase.expandRow(value.row);
							vm.gridApi.selection.selectRow(value.row.entity);
							value.row.userSet = true;
						}
					});
				});
			}
		};

		vm.operatorsList = [];
		vm.blurGrid = false;

		vm.filters = {
			logistic: null,
			programmed: null,
			delayed: null
		};


		vm.refreshing = false;
		vm.focusedRow = null;

		//vm.nProgrammed = 0;
		//vm.nDelayed = 0;
		vm.now = Date.NewDate().getTime();

		vm.reportService = reportService;

		/* PUBLIC FUNCTIONS */
		vm.getColorEstado = getColorEstado;
		vm.getTipoEstado = getTipoEstado;
		vm.getIconoOrden = getIconoOrden;
		vm.getTextoOrden = getTextoOrden;
		vm.getBrandLogo = getBrandLogo;
		vm.groupHeaderContent = groupHeaderContent;
		vm.showAssignDriver = showAssignDriver;
		vm.setGridData = setGridData;
		vm.getEstadoName = getEstadoName;
		vm.remove = remove;
		vm.assignOperatorToOrder = assignOperatorToOrder;
		vm.refreshData = refreshData;
		vm.selectAll = selectAll;
		vm.clearAll = clearAll;
		vm.invertSelection = invertSelection;
		vm.selectOrClear = selectOrClear;
		vm.changeOrderState = changeOrderState;
		vm.chatWithChofer = chatWithChofer;
		vm.acknowledgeDelay = acknowledgeDelay;
		vm.isGroupSelected = isGroupSelected;
		vm.groupSelect = groupSelect;
		vm.getRemainingTimeToAccept = getRemainingTimeToAccept;
		vm.goToEdit = goToEdit;
		vm.removeAllOrders = removeAllOrders;
		vm.getTextoEstadoAsig = getTextoEstadoAsig;

		vm.goToOrdenNueva = goToOrdenNueva;
		vm.reloadListener = null;


		$(window).on('active-orders-update-setGridData', function (e, args) {
			vm.setGridData();
		});

		/* INITIALIZER */
		(function () {
			//console.log('entra');

			//byArnau sets restante column without looking the value in the server
			fleet.getAllActiveLogistic().then(function (result) {
				//console.log(result);
				fleet.activeOrdersList = result;
				for (var i = 0; i < fleet.activeOrdersList.length; i++) {
					fleet.activeOrdersList[i].timestamp = (new Date()).getTime();
				}
				vm.setGridData();
			});

			if (!preferences.loaded) { preferences.getCompanyPrefs(); }

			//setInterval(function () {
			//    var t = (new Date()).getTime();
			//    for (var i = 0; i < fleet.activeOrdersList.length; i++) {
			//        fleet.activeOrdersList[i].tiempoRestante -= (t - fleet.activeOrdersList[i].timestamp) / 1000;
			//        fleet.activeOrdersList[i].timestamp = t;
			//    }
			//    // TODO: This generetes a memory leak (test with 1 second loop)
			//    vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
			//}, 10 * 1000);
		})();

		listeners.push($scope.$on('detail-resize', function (event, args) {
			//if ($rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('OrdenesActivas')].isActive()) {
				timeouts.push($timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0));
			//}
		}));

		function computeColumnsByOrderType() {
			if (preferences.prefs.sector === 'GRU') {
				return [
					{
						field: 'insurerId',
						displayName: '',
						width: 35,
						resizable: true,
						enableHiding: false,
						cellTemplate: templates.clienteCellTemplate
					},
					{
						name: 'tipo',
						displayName: '',
						width: 30,
						resizable: true,
						cellTemplate: templates.typeCellTemplate
					},
					{
						field: 'state',
						displayName: '',
						minWidth: 50,
						maxWidth: 70,
						resizable: true,
						cellTemplate: templates.estadoCellTemplateGRU,
						sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
							if (stateA === stateB) {
								if (rowA.entity.stateTime === rowB.entity.stateTime) {
									return 0;
								} else if (rowA.entity.stateTime > rowB.entity.stateTime) {
									return 1;
								} else {
									return -1;
								}
							} else if (stateA > stateB) {
								return 1;
							} else {
								return -1;
							}
						}
					},
					{
						field: 'id',
						displayName: 'Nº Orden',
						minWidth: 40,
						maxWidth: 80,
						resizable: true,
						visible: false
					},
					{
						field: 'expediente',
						displayName: 'Expediente',
						minWidth: 80,
						maxWidth: 80,
						resizable: true
					},
					{
						field: 'date',
						displayName: 'Fecha',
						minWidth: 70,
						maxWidth: 92,
						resizable: true,
						cellTemplate: templates.dateCellTemplate,
						sort: { priority: 1, direction: 'desc' }
					},
					{
						field: 'tiempoRestante',
						displayName: 'Restante',
						minWidth: 80,
						maxWidth: 80, // 100
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.delayCellTemplate,

					},
					{
						field: 'pickupAddress',
						displayName: 'Dirección de recogida',
						minWidth: 130,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.drecogidaCellTemplate,
						cellFilter: 'capitalize',
						sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
							if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
								return 0;
							}
							else if (rowA.entity.pickupTown > rowB.entity.pickupTown) {
								return 1;
							} else {
								return -1;
							}
						}
					},
					{
						field: 'deliveryAddress',
						displayName: 'Dirección de entrega',
						minWidth: 130,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.dentregaCellTemplate,
						cellFilter: 'capitalize',
						sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
							if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
								return 0;
							}
							else if (rowA.entity.deliveryTown > rowB.entity.deliveryTown) {
								return 1;
							} else {
								return -1;
							}
						}
					},
					{
						field: 'brand',
						displayName: 'Marca',
						minWidth: 62,
						maxWidth: 100,
						resizable: true,
						cellFilter: 'capitalize',
						cellTemplate: templates.brandCellTemplate
					},
					{
						field: 'plate',
						displayName: 'Matrícula',
						minWidth: 78,
						maxWidth: 78,
						resizable: true,
					},
					{
						field: 'fault',
						displayName: 'Avería',
						minWidth: 60,
						maxWidth: 85,
						resizable: true,
						cellFilter: 'capitalize'
					},
					{
						field: 'fleetId',
						displayName: '',
						minWidth: 30,
						maxWidth: 30,
						resizable: true,
						cellFilter: 'capitalize',
						cellTemplate: templates.vehicleCellTemplate
					},
					{
						field: 'assignedDriver',
						displayName: 'Chofer',
						width: 70,
						resizable: true,
						cellTemplate: templates.choferCellTemplate,
						cellFilter: 'capitalize'
					},
					{
						field: 'grouping',
						grouping: { groupPriority: 0 },
						enableHiding: false,
						sort: { priority: 0, direction: 'asc' },
						visible: false
					},
					{
						name: 'acciones',
						displayName: 'Acciones',
						width: 150,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.accionesCellTemplate,
						enableHiding: false,
						enableSorting: false
					}
					// {
					//     name: 'acciones',
					//     displayName: 'Acciones',
					//     width: 140,
					//     resizable: true,
					//     cellClass: 'overflow',
					//     cellTemplate: templates.accionesCellTemplate,
					//     enableHiding: false,
					//     enableSorting: false
					// }
				];
			}
			else if (preferences.prefs.sector === 'TAX') {
				return [
					{
						field: 'insurerId',
						displayName: '',
						width: 40,
						resizable: true,
						enableHiding: false,
						cellTemplate: templates.clienteCellTemplate
					},
					{
						field: 'state',
						displayName: '',
						minWidth: 40,
						maxWidth: 100,
						resizable: true,
						cellTemplate: templates.estadoCellTemplateTAX,
						sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
							if (stateA === stateB) {
								if (rowA.entity.stateTime === rowB.entity.stateTime) {
									return 0;
								} else if (rowA.entity.stateTime > rowB.entity.stateTime) {
									return 1;
								} else {
									return -1;
								}
							} else if (stateA > stateB) {
								return 1;
							} else {
								return -1;
							}
						}
					},
					{
						field: 'id',
						displayName: 'Nº Orden',
						minWidth: 40,
						maxWidth: 80,
						resizable: true
					},
					{
						field: 'expediente',
						displayName: 'Expediente',
						minWidth: 90,
						maxWidth: 130,
						resizable: true
					},
					{
						field: 'date',
						displayName: 'Fecha',
						minWidth: 70,
						maxWidth: 130,
						resizable: true,
						cellTemplate: templates.dateCellTemplate,
						sort: { priority: 1, direction: 'desc' }
					},
					{
						field: 'delayTime',
						displayName: 'Restante',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						cellTemplate: templates.delayCellTemplate,
					},
					{
						field: 'pickupAddress',
						displayName: 'Dirección de recogida',
						minWidth: 160,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.drecogidaCellTemplate,
						cellFilter: 'capitalize'
					},
					{
						field: 'deliveryAddress',
						displayName: 'Dirección de entrega',
						minWidth: 160,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.dentregaCellTemplate,
						cellFilter: 'capitalize',
					},
					{
						field: 'plate',
						displayName: 'Matrícula',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
					},
					{
						field: 'pax',
						displayName: 'PAX',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numVuelo',
						displayName: 'Vuelo',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'equipajeL',
						displayName: 'Grande',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'equipajeM',
						displayName: 'Mediana',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'equipajeS',
						displayName: 'Pequeña',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numSillasGrupo1',
						displayName: 'NumSillasGrupo1',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numSillasGrupo2',
						displayName: 'NumSillasGrupo2',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numSillasGrupo3',
						displayName: 'NumSillasGrupo3',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numBolsasGolf',
						displayName: 'Bolsa Golf',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numBicicletas',
						displayName: 'Bicicleta',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'numTransportines',
						displayName: 'Transportin',
						minWidth: 80,
						maxWidth: 100,
						resizable: true,
						visible: false
					},
					{
						field: 'fleetId',
						displayName: 'Vehículo',
						minWidth: 75,
						maxWidth: 90,
						resizable: true,
						cellFilter: 'capitalize',
						cellTemplate: templates.vehicleCellTemplate
					},
					{
						field: 'assignedDriver',
						displayName: 'Chofer',
						width: 85,
						resizable: true,
						cellTemplate: templates.choferCellTemplate,
						cellFilter: 'capitalize'
					},
					{
						field: 'grouping',
						grouping: { groupPriority: 0 },
						enableHiding: false,
						sort: { priority: 0, direction: 'asc' },
						visible: false
					},
					{
						name: 'acciones',
						displayName: 'Acciones',
						width: 150,
						resizable: true,
						cellClass: 'overflow',
						cellTemplate: templates.accionesCellTemplate,
						enableHiding: false,
						enableSorting: false
					}
				];
			}


		}

		function countTimeEachSecond() { //Update the time each second so angular refreshes it in the ui each second
			vm.now = Date.NewDate().getTime();
			timeouts.push($timeout(countTimeEachSecond, 1000));
		}

		/* FUNCTION DEFINITIONS */
		function setGridData() {

			//$scope.gridData = $filter('filter')(fleet.activeOrders, filterExpression);
			$scope.gridData = $filter('filter')(fleet.activeOrdersList, filterExpression);

			//Search box (OR filter) 
			var filterInfo = {
				expediente: vm.searchText,
				plate: vm.searchText,
				assignedDriver: vm.searchText,
				fleetId: vm.searchText,
				fault: vm.searchText,
				model: vm.searchText,
				brand: vm.searchText,
				deliveryTown: vm.searchText,
				deliveryAddress: vm.searchText,
				pickupTown: vm.searchText,
				pickupAddress: vm.searchText
			};
			$scope.gridData = $filter('searchFilter')($scope.gridData, filterInfo, true);

			countOrderProperties();

			if (!common.isNullOrUndefined(vm.gridApi))
				vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
		}

		function filterExpression(value, index, array) {
			//Logistica/Asistencia filter
			if (vm.filters.logistic !== null && vm.filters.logistic !== value.isLogistica) { return false; }

			//Delayed filter
			if (vm.filters.delayed && (value.tiempoRestante >= 0 || value.viewDelay !== false)) { return false; }

			//Programmed filter
			if (vm.filters.programmed && !value.programada) { return false; }

			return true;
		}
		function countOrderProperties() {
			//vm.nProgrammed = 0;
			//vm.nDelayed = 0;
			//angular.forEach($scope.gridData, function (value, key) {
			//    //Counts
			//    //if(value.programada) { vm.nProgrammed += 1; }
			//    if (value.tiempoRestante < 0 && value.viewDelay === false) { vm.nDelayed += 1; }
			//});
		}

		function refreshData(success) {
			vm.refreshing = true;
			fleet.getMapData().then(function () {
				if (success) {
					notificationService.sendAppNotification({
						message: 'Orden eliminada con éxito',
						positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
					});
				}
				vm.refreshing = false;
			});
		}

		function clearSearcher() {
			vm.searchText = '';
			setGridData();
		}

		/* ROW SELECTION */
		function selectAll() {
			vm.gridApi.selection.selectAllRows();
		}
		function clearAll() {
			vm.gridApi.selection.clearSelectedRows();
		}
		function invertSelection() {
			var selected = vm.gridApi.selection.getSelectedRows();

			vm.selectAll();

			for (var i = 0; i < selected.length; i++) {
				vm.gridApi.selection.unSelectRow(selected[i]);
			}
		}
		function selectOrClear() {
			if (vm.gridApi.selection.getSelectAllState()) {
				vm.clearAll();
			} else {
				vm.selectAll();
			}
		}

		/* Aceptación servicios */
		function getRemainingTimeToAccept(date, order) {
			var altaDate = new Date(order.altaDate);
			var compute = parseInt((date - altaDate.getTime()) / 1000);
			return (order.timeAsignation || 300) - compute;
		}

		/* Asignación chofer */
		function showAssignDriver(orderId, order) { //MODAL
			vm.operatorsList = [];
			fleet.getAssignableOperators(orderId).then(function (data) {
				vm.operatorsList = data;
			});

			ModalService.showModal({
				template: assignDriverTemplate,
				controller:
					function (close) {
						var modal = this;
						modal.parentScope = vm;

						modal.companyName = order.clientName;
						modal.companySrc = vm.getBrandLogo(order.insurerId);
						modal.tMedio = order.vehicleType;

						modal.cancel = function () {
							$rootScope.blurry = false;
							close();
						};
					},
				controllerAs: 'modal'
			});
		}
		function assignOperatorToOrder(orderId, operatorId, state, modal, confirm) {
			//if (operatorId == null) {
			//	simpleModalService.yesNoModal('Confirmación desasignar chofer',
			//		'¿Desea desasignar el chofer de la orden?')
			//		.then(function (result) {
			//			if (result) {
			//				ordersService.assignToOperator(null, orderId).then(function (result) {
			//					vm.refreshData();
			//				});
			//			}
			//		});
			//} else {
			//	if (state !== 100 || confirm) {
			//		vm.blurGrid = true;
			//		ordersService.assignToOperator(operatorId, orderId).then(function (result) {
			//			vm.modal1 = false;
			//			vm.blurGrid = false;
			//			fleet.getMapData().then(function () {
			//				if (modal) {
			//					modal.cancel();
			//				}
			//			});
			//		});
			//	}
			}

		/* Order actions */
		function remove(id) {
			if (id == null) { return; }
			simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la orden?')
				.then(function (result) {
					if (result) {
						notificationService.sendAppNotification({
							message: 'Eliminando orden...',
							positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
						});
						ordersService.removeOrders([id]).then(
							function () {
								notificationService.sendAppNotification({
									message: 'Orden eliminada con éxito',
									positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
								});
							}, function () {
								notificationService.sendAppNotification({
									message: 'Ha ocurrido un error al eliminar la orden',
									positionY: 'top', positionX: 'right', delay: null, type: 'error'
								});
							});
						vm.refreshData();
					}
				});
		}

		function changeOrderState(orderId, state) {
			ordersService.legacyChangeOrderState(orderId, state)
				.then(function () { refreshData(); });
		}

		function acknowledgeDelay(order) {
			ordersService.acknowledgeDelay(order.orderId).then(function (result) {
				vm.refreshData();
			});
		}

		function goToEdit(orderId) {
			vm.focusedRow = orderId;
			$rootScope.tabManager.goToOrdenes(orderId);
		}

		function chatWithChofer(choferId) {
			$state.go('flota.chat', { 'id': choferId });
		}

		function groupHeaderContent(row, cols) {
			var header = 'nuevas';
			if (row.treeNode.aggregations[0].groupVal === 1) { header = 'notificaciones'; }
			if (row.treeNode.aggregations[0].groupVal === 2) { header = 'pendientes'; }
			if (row.treeNode.aggregations[0].groupVal === 3) { header = 'en curso'; }
			if (row.treeNode.aggregations[0].groupVal === 4) { header = 'finalizadas hoy'; }
			return header;
		}

		/* Group selection */
		function isGroupSelected(row) {
			for (var i = 0; i < row.treeNode.children.length; i++) {
				if (!row.treeNode.children[i].row.isSelected) {
					row.groupSelected = false;
					return false;
				}
			}
			row.groupSelected = true;
			return true;
		}
		function groupSelect(row) {
			angular.forEach(row.treeNode.children, function (value, key) {
				if (row.groupSelected) {
					vm.gridApi.selection.unSelectRow(value.row.entity);
				} else {
					vm.gridApi.selection.selectRow(value.row.entity);
				}
			});
		}

		function getColorEstado(estado) {
			return preferences.prefs.getStateColor(estado) || 'undefined';
		}

		function getTipoEstado(tipo) {
			
			return userConfig.literals.estadosOrden[tipo] || $filter('initials')(vm.getEstadoName(tipo));
		}

		function getEstadoName(estado) {
			return preferences.prefs.getStateDesc(estado) || '-';
		}

		function getIconoOrden(tipo) {
			return userConfig.orders.iconoOrden[tipo] || 'undefined';
		}

		function getBrandLogo(tipo) {
			if (tipo === null) { return null; }
			return userConfig.brands.insurance[tipo] || null;
		}

		function getTextoOrden(tipo) {
			return userConfig.orders.textoOrden[tipo] || 'en';
		}

		function removeAllOrders() {
			simpleModalService.yesNoModal('Confirmación eliminar',
				'¿Desea eliminar las ' + vm.gridApi.selection.getSelectedCount() + ' ordernes seleccionadas?')
				.then(function (result) {
					if (result) {
						var orderIds = [];
						var selected = vm.gridApi.selection.getSelectedRows();
						for (var i = 0; i < selected.length; i++) {
							orderIds.push(selected[i].orderId);
						}
						notificationService.sendAppNotification({
							message: 'Eliminando ordenes...',
							positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
						});
						ordersService.removeOrders(orderIds)
							.then(
								function () {
									vm.refreshData(true);
									notificationService.sendAppNotification({
										message: 'Ordenes eliminadas con éxito',
										positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
									});
								}, function () {
									notificationService.sendAppNotification({
										message: 'Ha ocurrido un error al eliminar las ordenes',
										positionY: 'top', positionX: 'right', delay: null, type: 'error'
									});
								}
							);
					}
				});
		}

		$scope.$on('$destroy', function () {

			if (vm.reloadListener != null)
				vm.reloadListener();

			listeners.forEach(element => {
				element();
			});
			timeouts.forEach(element => {
				$timeout.cancel(element);
			});

		});

		function getTextoEstadoAsig(estadoAsig) {
			/*jshint maxcomplexity:false */
			switch (estadoAsig) {
				case 0:
					return 'Pendiente aceptación';
				case 1:
					return 'Aceptado pendiente confirmación';
				case 2:
					return 'Rechazado pendiente confirmación';
				case 3:
					return 'Rechazado timeout pendiente confirmación';
				case 4:
					return 'Error reintentar';
				case 5:
					return 'Error no reintentar';
				case 6:
					return 'Rechazado colaborador desconectado pendiente confirmación';
				case 7:
					return 'Aceptado sin confirmación';
				case 8:
					return 'Modificado sin confirmación';
				case 9:
					return 'Baja sin confirmación';
				case 10:
					return 'Pendiente presupuesto';
				case 11:
					return 'Pendiente aceptación presupuesto';
				case 100:
					return 'Aceptado';
				case 101:
					return 'Rechazado';
				case 102:
					return 'Rechazado timeout';
				case 103:
					return 'Rechazado colaborador desconectado';
				case 104:
					return 'Modificado';
				case 105:
					return 'Baja';
				case 106:
					return 'Rechazado presupuesto';
				case 107:
					return 'Aceptado presupuesto';
				default:
					return '-';
			}
		}

		function goToOrdenNueva() {
			$rootScope.tabManager.goToOrdenes(null);
		}

		function onMouseLeaveDelayCell(btnDeactivateId, containerId) {
			var btn = document.getElementById(btnDeactivateId);
			var c = document.getElementById(containerId);
			btn.classList.add('none');
			c.classList.remove('none');

		}

		function onMouseOverDelayCell(btnDeactivateId, containerId) {
			var btn = document.getElementById(btnDeactivateId, containerId);
			var c = document.getElementById(containerId);
			btn.classList.remove('none');
			c.classList.add('none');
		}

		function getDelayState(item) {
			if (item.tiempoRestante >= 0) {
				return 'delay-positive';
			}

			if (item.tiempoRestante < 0 && item.viewDelay == false) {
				return 'delay-not-viewed-negative';
			}

			if (item.tiempoRestante < 0 && item.viewDelay == true) {
				return 'delay-viewed-negative';
			}

			return 'delay-default';
		}

		function getStateClassName(item) {

			switch (item.estadoOrden) {
				case 500:
					return 'state-modificado-sin-conf';
				case 501:
					return 'state-baja-sin-conf';
				case 502:
					return 'state-baja';
				case 503:
					return 'state-modificado';
				default:
					return 'state-undefined';
			}
		}

		function getStateLabel(item) {

			switch (item.estadoOrden) {
				case 500:
					return 'Modificado SIN conf.';
				case 501:
					return 'Baja SIN conf.';
				case 502:
					return 'Baja';
				case 503:
					return 'Modificado';
				default:
					return 'undefined';
			}
		}
	}
})();
